import { render, staticRenderFns } from "./BaseSwitchButton.vue?vue&type=template&id=16a5bc28&scoped=true"
import script from "./BaseSwitchButton.vue?vue&type=script&lang=js"
export * from "./BaseSwitchButton.vue?vue&type=script&lang=js"
import style0 from "./BaseSwitchButton.vue?vue&type=style&index=0&id=16a5bc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a5bc28",
  null
  
)

export default component.exports